// JSON updated by Republic
const FLAT_BALLOT_URL =
  'https://s3.us-east-1.amazonaws.com/sos-test-2.texastribune.org/2026_general/ballot_page/results_FLAT_for_ballot_test.json';

// Branch API (VoterGuideOS) local races and elections
const BRANCH_API_BASE = 'https://www.branch.vote/api/v1';
const BRANCH_ORG_ID = '6a91a5e29f7c4de2d9e86f8a';
const BRANCH_ELECTION_KEY = '2026-texas-general-election';

export { FLAT_BALLOT_URL, BRANCH_API_BASE, BRANCH_ORG_ID, BRANCH_ELECTION_KEY };
